<template>
  <div class="app-nav">
    <div class="grid gap-3 mb-0">
      <AppLogo class="text-[2.25rem]" />
      <AppNavigationLocation />
    </div>
    <div class="overflow-y-auto no-scrollbar py-4 md:py-8">
      <AppNavigationItems />
    </div>
    <div class="flex flex-col gap-4" v-auto-animate>
      <div v-if="route.name !== 'search' || route.query.drawer">
        <NuxtLink :to="{ name: 'search' }">
          <div class="border bg-mist/50 px-3 py-2 rounded text-sm text-[#888] relative flex items-center gap-2">
            <AtomIcon name="magnifying-glass" class="my-1" />
            <span class="text-sm">{{ $t('shared.searchRestaurant') }}</span>
          </div>
        </NuxtLink>
      </div>
      <div v-if="!['fat'].includes(route.name) || route.query.drawer">
        <button class="button-coral w-full" @click="goToFat">
          {{ $t('shared.searchFreeTable') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const router = useRouter()

// Push FAT route instead of using indexable link
const goToFat = () => {
  router.push({ name: 'fat' })
}
</script>

<style lang="scss" scoped>
.app-nav {
  @apply flex flex-col h-full;
}
</style>